import { FormDesignAddForm } from "components/Forms/FormDesignAddForm/FormDesignAddForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface FormAddFormProps {
    onSubmit: () => void;
}

export const FormDesignAddDrawer: FC<FormAddFormProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.form-design-add");
    const id = DrawerId.FormDesignAdd;

    return (
        <Drawer drawerId={id} title={<DrawerTitle mainTitle={t("title")} />}>
            <FormDesignAddForm onSubmit={onSubmit} />
        </Drawer>
    );
};
